import { render, staticRenderFns } from "./About.vue?vue&type=template&id=440e72ec&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=440e72ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440e72ec",
  null
  
)

export default component.exports